import i18next from '@app/i18n'

i18next.addResourceBundle("en", "Chameleon", {
    launchTutorialButton: "Tutorial",
});

i18next.addResourceBundle("fr", "Chameleon", {
    launchTutorialButton: "Tutoriel",
});